import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Text, TextType } from 'ui-components/components/text';
import style from './style.module.less';
import { messages } from './messages';

export const DeallocationWarningModal = ({ onCloseModal, orderCount, onConfirmation }) => {
  return (
    <Modal>
      <ModalHeader closeModal={onCloseModal}>
        <span className={style['modal-body-header']}>
          <Text textType={TextType.H2} value={messages.deallocationWarningModalTitle} />
        </span>
      </ModalHeader>
      <ModalBody className={style['warning-modal-body']}>
        <div className={style['warning-content']}>
          <span>
            <FontAwesomeIcon className={style['warning-icon']} icon={faExclamationTriangle} />
          </span>
          <span className={style['warning-text']}>
            <Text formattedMessageValues={{ orderCount }} textType={TextType.Caption} value={messages.deallocationWarningModalBody} />
          </span>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className={style['modal-buttons']}>
          <Button onClick={onCloseModal}>
            <Text textType={TextType.Paragraph} value={messages.deallocateWarningModalCancel} />
          </Button>
          <Button className={style['confirm-button']} onClick={onConfirmation}>
            <Text textType={TextType.Paragraph} value={messages.deallocateWarningModalConfirm} />
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

DeallocationWarningModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  orderCount: PropTypes.number.isRequired,
  onConfirmation: PropTypes.func.isRequired,
};
